import React from 'react'
import { PageNotFound } from 'component-library/errors/PageNotFound/PageNotFound'

export const TheWestPageNotFound = () => <PageNotFound attribution />
